import React from 'react';
import { X } from 'lucide-react';
import StepShell from './StepShell';
import type { FlowCtx } from './types';

interface Props {
  ctx: FlowCtx;
}

const Step8DeviceConnectionFailed: React.FC<Props> = ({ ctx }) => {
  return (
    <StepShell
      stepNumber={4}
      onBack={ctx.openExitModal}
      secondary={{ label: 'Back', onClick: () => ctx.goTo('wificonf') }}
      primary={{
        label: 'Retry',
        onClick: () => ctx.goTo('wificonf'),
      }}
    >
      <div className="dcf-content--center">
        <h2 className="dcf-step-title">
          Step 4 of 4: Device not connected
        </h2>
        <div className="dcf-step-bar"></div>

        <div className="dcf-image-source">
          <picture>
            <source
              srcSet={`${process.env.PUBLIC_URL}/DeviceSetup/device-mobile.avif`}
              type="image/avif"
            />
            <img
              srcSet={`${process.env.PUBLIC_URL}/DeviceSetup/device-mobile.webp`}
              alt="SmartEco IAQ device"
              className="dcf-illustration"
            />
          </picture>

          <picture className='dcf-indicator'>
            <source
              srcSet={`${process.env.PUBLIC_URL}/DeviceSetup/all-failed-indicator.avif`}
              type="image/avif"
            />
            <img
              src={`${process.env.PUBLIC_URL}/DeviceSetup/all-failed-indicator.webp`}
              alt="SmartEco IAQ device"
              className="dcf-indicator-image"
            />
          </picture>

          <div
            className="dcf-status-icon dcf-step7-status-icon dcf-status-icon--danger"
            aria-hidden="true"
          >
            <X strokeWidth={2} />
          </div>
        </div>

        <span className="dcf-step-subtitle live dcf-step-subtitle--danger">
          Device is Inactive
        </span>
        <p className="dcf-step-subtitle">
          Your Smart Eco device is offline. Please follow the below steps
          properly to get the device active and then &lsquo;retry&rsquo;.
        </p>

        <ol className="dcf-info-list dcf-info-list--numbered" style={{ marginTop: 8 }}>
          <li className="dcf-info-list__item">
            <span className="dcf-info-list__num">1</span>
            You were connected to &ldquo;IAQ_&rdquo; during set-up
          </li>
          <li className="dcf-info-list__item">
            <span className="dcf-info-list__num">2</span>
            Your Wi-Fi name and password are correct
          </li>
          <li className="dcf-info-list__item">
            <span className="dcf-info-list__num">3</span>
            <span>Device must be connected with <strong>2.4GHz only</strong></span>
          </li>
        </ol>
      </div>
    </StepShell>
  );
};

export default Step8DeviceConnectionFailed;
